import './singleBlog.scss';

import { graphql, useStaticQuery } from 'gatsby';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GatsbyImage } from 'gatsby-plugin-image';
import { IBlog } from '../../interfaces/interfaces';
import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import rightArrowIconPrimary from '../../images/englander-icons/Right-Arrow-Icon-Primary.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function SingleBlog(props: {
    blog: IBlog | any;
    displayFaqBloc?: boolean;
}) {
    const { blog, displayFaqBloc = false } = props;
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('pages');

    const { allProductsJson } = useStaticQuery(
        graphql`
            query {
                allProductsJson(
                    filter: { code: { eq: "englander_blog-faq" } }
                ) {
                    nodes {
                        code
                        title {
                            fr_CA
                            en_US
                            en_CA
                        }
                        attributes {
                            texte_1 {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                            texte_2 {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                            texte_3 {
                                values {
                                    fr_CA
                                    en_US
                                    en_CA
                                }
                            }
                            link {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                            bouttons {
                                values {
                                    fr_CA
                                    en_US
                                    en_CA
                                }
                            }
                        }
                    }
                }
            }
        `
    );
    const blogFacBloc = allProductsJson?.nodes?.[0];

    return (
        <>
            <div className='blog-single'>
                {blog?.fields?.images?.[0] ? (
                    <GatsbyImage
                        onClick={() =>
                            navigateTranslated(
                                `/blogArchives/${
                                    blog.code.replace('englander_', '') + '/'
                                }`
                            )
                        }
                        image={
                            blog.fields.images[0]?.childImageSharp
                                ?.gatsbyImageData
                        }
                        alt=''
                        className='blog-image'
                    />
                ) : (
                    <div className='image-placeholder'>
                        <div>
                            <FontAwesomeIcon icon={faExclamationCircle} />
                            <span>no image</span>
                        </div>
                    </div>
                )}
                <span className='blog-title'>
                    {blog?.title?.[currentLocale]}
                </span>
                <LocalizedLink
                    className='read-more'
                    label={t('blogs.read-more')}
                    to={`blogArchives/${
                        blog.code.replace('englander_', '') + '/'
                    }`}
                >
                    <img src={rightArrowIconPrimary} alt='' />
                </LocalizedLink>
            </div>

            {displayFaqBloc && (
                <div className='faq-bloc'>
                    <p className='faq-title'>
                        {blogFacBloc?.title[currentLocale]}
                    </p>
                    <div className='faq-content'>
                        <span>
                            {
                                blogFacBloc?.attributes?.texte_1?.values?.[0][
                                    currentLocale
                                ]
                            }
                        </span>
                        <span>
                            {
                                blogFacBloc?.attributes?.texte_2?.values?.[0][
                                    currentLocale
                                ]
                            }
                        </span>
                        <span>
                            {
                                blogFacBloc?.attributes?.texte_3?.values?.[0][
                                    currentLocale
                                ]
                            }
                        </span>
                    </div>
                    <Button
                        className='englander-button'
                        link={
                            blogFacBloc?.attributes?.link?.values?.[0][
                                currentLocale
                            ]
                        }
                        label={
                            blogFacBloc?.attributes?.bouttons?.values?.[0][
                                currentLocale
                            ]
                        }
                    />
                </div>
            )}
        </>
    );
}
